<template>
  <div class="data-list-container">
<vs-card>
      <div class="flex justify-between items-center mb-6">
        <div class="inline-flex items-center">
          <div class="light_blue_icon_holder">
            <span class="material-icons-outlined">person_outline</span>
          </div>
          <h4 style="text-transform: capitalize;" class="pl-2">{{$route.params.name}} Role Management</h4>
        </div>
        <vs-button @click="saveButton">Back</vs-button>
      </div>
      <vs-divider />
      <div class="tab_router_link_holder">
        <router-link 
          :to="{
            name: 'role-module-set-access',
            params: { moduleId: $route.params.moduleId,
            name: $route.params.name
            }
          }"
        > 
          <span class="material-icons-outlined">event</span>
          <span class="pl-2">Roles & Access Permissions</span>
        </router-link>
        <router-link 
          class="active"
          :to="{
            name: 'role-user-module-access',
            params: { moduleId: $route.params.moduleId,
            name: $route.params.name
            }
          }"
        > 
          <span class="material-icons-outlined">person</span>
          <span class="pl-2">User Info Editing settings</span> 
        </router-link>
      </div>
      <!-- <div style="display:flex" class="m-2">
              <h4>All Permission</h4> <vs-checkbox color="success" />
                <vs-col vs-type="flex" vs-justify="center" vs-align="center"  vs-w="6" style="height:100%"

      </div> -->
      <strong class="block pt-0 p-2">User Info Editing settings</strong>
      <vs-row>

  <!-- <vs-col vs-type="flex" vs-justify="center" vs-align="center"  vs-w="3" style="height:100%"
  v-for="list in sublist" :key="list.platform_module_id"
  > -->
  
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12" style="height:100%"
   v-for="list in sublist" :key="list.platform_sub_module_id" class="p-2"
  >

<vs-card vs-type="flex" class="content_mb_0 mb-0">
  <div style="display:flex;justify-content:space-between">
  <h6>{{list.sub_module_name}}</h6>
     <vs-checkbox 
        color="primary"
        v-model="list.enabled"

        @change="changeSubModulePermission(list.enabled,list.platform_module_id,list.platform_sub_module_id)"
        >
    </vs-checkbox>
  </div>
</vs-card>
  </vs-col>
  

          <!-- <vs-card 
          v-if="list.sub_module_list.length"
          class="mr-2" style="height:100%">
              <vs-list>

                 <vs-list-header
                  
                   :title="list.module_name"
                   color="white"
                   style="background-color: rgb(65,207,221);
                   justify-content:center;"

                  ></vs-list-header> -->
<!--               
                  <vs-list-item
                  v-for="listaction in list.sub_module_list" :key="listaction.platform_sub_module_id"
                   :title="listaction.sub_module_name">
                      <vs-checkbox 
                      v-model="listaction.enabled"
                      color="success"
                      @change="permission(listaction.enabled,listaction.platform_sub_module_id,list.platform_module_id)"
                      >
                      </vs-checkbox>

                  </vs-list-item> -->
                        
                  <!-- <vs-list-item
                  v-for="listaction in list.action_list" :key="listaction.role_action_id"
                   :title="listaction.action_name">
                      <vs-checkbox 
                      v-model="listaction.enabled"
                      color="success"
                      @change="permission(listaction.enabled,listaction.role_action_id,list.platform_module_id)"
                      >
                      </vs-checkbox>
                  </vs-list-item> -->
  
                   <!-- <vs-list-item title="Email">
                  <vs-checkbox color="success"/>
                  </vs-list-item>
                   <vs-list-item title="Address">
                  <vs-checkbox color="success"/>
                  </vs-list-item>
                   <vs-list-item title="biodata">
                  <vs-checkbox color="success"/>
                  </vs-list-item> 

                    <vs-list-item title="personal preference">
                  <vs-checkbox color="success"/>
                  </vs-list-item> 

                    <vs-list-item title="Education">
                  <vs-checkbox color="success"/>
                  </vs-list-item> 

                    <vs-list-item title="Awards">
                  <vs-checkbox color="success"/>
                  </vs-list-item> 

                  <vs-list-item v-if="index % 2 ===0" title="Display Role Listing">
                  <vs-checkbox color="success"/>
                  </vs-list-item> 

                  <vs-list-item v-if="index % 2 ===0"  title="Display Role Listing">
                  <vs-checkbox color="success"/>
                  </vs-list-item> 

                  <vs-list-item v-if="index % 2 ===0" title="Display Role Listing">
                  <vs-checkbox color="success"/>
                  </vs-list-item>  -->
              <!-- </vs-list>

          </vs-card> -->

           <!-- </vs-col> -->


</vs-row>

<!-- <vs-row vs-type="flex" vs-justify="flex-end">
      <vs-button color="primary"
      style="float:right" @click="saveButton">Back</vs-button>

</vs-row> -->
</vs-card>
  </div>
</template>

<script>
import {  ModluePermission, FetchSubModule, SubModulePermission } from '@/api/role'

export default {
  data () {
    return {
      sublist:[]
    }
  },
  mounted () {
    this.fetch_sub_module_list()
  },
  methods:{
    saveButton () {

      this.$router.push({ name: 'v1-settings', params: {tabIndex: 2}})
     
    },
    
    async fetch_sub_module_list () {
      this.$vs.loading()

      try {
        const customerId = localStorage.getItem('customer_id')
        const { data } = await FetchSubModule(this.$route.params.moduleId, customerId)
        
        
        this.sublist = data.data.list
        //  this.sublist.map(element => element.module_name === 'Users')
        
        // 
        this.$vs.loading.close()


        // this.custom_fields = data.data.custom_fields
        // this.entityModel = data.data.entitymodels
        // 
      

      } catch (error) {
        
        this.$vs.loading.close()

        // this.$vs.loading.close()
      }

    },
    permission (enable, roleactionid, platformmoduleid) {
      const payload = {
        role_action_id : roleactionid,
        platform_module_id : platformmoduleid,
        user_roles_id : this.$route.params.moduleId,
        enabled  : enable ? 1 : 0 
      }

      this.PermissionModuleSet(payload)
      
    },
    async PermissionModuleSet (payload) {
      this.$vs.loading()

      try {
        const data  = await ModluePermission(payload)
        
        
        this.$vs.notify({
          title: 'Success',
          text: 'Platform Module Action Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.$vs.loading.close()

      } catch (error) {
        
        this.$vs.loading.close()
      }
    },
    
    changeSubModulePermission (enable, platformmoduleid, platformsubmoduleid) {
      console.log(enable)
      const customerId = localStorage.getItem('customer_id')
      const payload = {
        platform_module_id : platformmoduleid,
        platform_sub_module_id : platformsubmoduleid,
        user_role_id : this.$route.params.moduleId,
        enabled  : enable ? 1 : 0,
        customer_id:customerId
      }
     

      this.PermissionModuleSubSet(payload)
    },

    async PermissionModuleSubSet (payload) {
      this.$vs.loading()

      try {
        const data  = await SubModulePermission(payload)
        
        
        this.$vs.notify({
          title: 'Success',
          text: 'Sub Module Access Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.$vs.loading.close()

      } catch (error) {
        
        this.$vs.loading.close()
      }
    }

  }
}
</script>

<style scoped>
  .vs-checkbox--input {
    height: 100px;
    width: 100px;
  }
</style>